import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Title from "../../../Components/Title";
import replaceTweetText from "fuction/replaceTweetText";
import LaunchIcon from "@material-ui/icons/Launch";
import dayjs from "dayjs";

dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  row: {
    lineHeight: "1.5em",
    height: "5.1em",
  },
  loading: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    fontSize: "20px",
  },
  content: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    cursor: "pointer",
    wordBreak: "break-word",
  },
  postDate: {
    display: "block",
    marginTop: "6px",
    textAlign: "right !important",
    color: "rgba(0, 0, 0, 0.54)",
  },
  rightCell: {
    color: "#ee3333",
    whiteSpace: "nowrap",
  },
  count: {
    display: "block",
    textAlign: "center",
  },
  launchIcon: {
    display: "block",
    textAlign: "center",
  },
}));

export default function Retweet(props) {
  const classes = useStyles();

  const createdAt = (row) => {
    // ツイートがリツイートならば元のツイートの投稿日時を返す
    if (row.tweet.retweeted_status) {
      return row.tweet.retweeted_status.created_at;
    } else {
      return row.tweet.created_at;
    }
  }

  const tweetLink = (row) => {
    let tweetLink = "";
    // ツイートがリツイートならば元のツイートのリンクを返す
    if (row.tweet.retweeted_status) {
      tweetLink = "https://twitter.com/" + row.tweet.retweeted_status.user.screen_name 
        + "/status/" + row.tweet.retweeted_status.id_str;
    } else {
      tweetLink = "https://twitter.com/" + row.tweet.user.screen_name 
        + "/status/" + row.tweet.id_str;
    }
    return tweetLink;
  }

  const contents = () => {
    if (!props.isApiReturn) {
      return [...Array(10)].map((row, index) => (
        <TableRow key={index} className={classes.row}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>
            <span className={classes.loading}>Loading...</span>
          </TableCell>
        </TableRow>
      ));
    } else {
      if (props.content.length > 0) {
        return props.content.map((row, index) => (
          <TableRow
            key={index}
            className={classes.row}
            hover
          >
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span
                className={classes.content}
                onClick={() => props.handleClickRow(row.retweet)}
              >
                {replaceTweetText(row.tweet)}
              </span>
              <span className={classes.postDate}>
                {dayjs(createdAt(row)).format("YYYY/MM/DD HH:mm:ss")}
              </span>
            </TableCell>
            <TableCell className={classes.rightCell}>
              <span className={classes.count}>{row.count}件</span>
              <span className={classes.launchIcon}>
                <a
                  href={tweetLink(row)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LaunchIcon />
                </a>
              </span>
            </TableCell>
          </TableRow>
        ));
      } else {
        return [...Array(10)].map((row, index) => (
          <TableRow key={index} className={classes.row}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span className={classes.content}>-</span>
            </TableCell>
            <TableCell className={classes.rightCell}>
              <span className={classes.count}>-</span>
              <span className={classes.launchIcon}></span>
            </TableCell>
          </TableRow>
        ));
      }
    }
  };
  return (
    <React.Fragment>
      <Title>話題</Title>
      <Table size="small">
        <TableBody>{contents()}</TableBody>
      </Table>
    </React.Fragment>
  );
}
